export default __webpack_public_path__ + "static/media/euro.db7b2847.svg";